import { Modal, Text } from "@mantine/core";
import { memo, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { type ISection } from "../../../../interfaces";
import HistoryModalGenerator from "./Content/HistoryModalGenerator";
import HistoryModalSection from "./Content/HistoryModalSection";
import HistoryModalTable from "./Content/HistoryModalTable";

interface Props {
  opened: boolean;
  close: () => void;
  summary?: boolean;
  requestBody?: any;
  hideAutosave?: boolean;
}

const HistoryModal = ({
  opened,
  close,
  summary,
  requestBody,
  hideAutosave,
}: Props) => {
  const [section, setSection] = useState<ISection>();

  // Ensure the flag is cleared when the box closes as this is causing an issue with saves as the box after a save =>
  // page navigation keeps the flag in the URL that then re shows the box after the save => nav.
  const [, setSearchParams] = useSearchParams();
  const closeHandler = () => {
    setSearchParams(
      prev => {
        prev.delete("fromHistory");
        return prev;
      },
      { replace: true },
    );

    if (close) {
      close();
    }
  };

  return (
    <Modal
      h={500}
      size="80%"
      opened={opened}
      onClose={closeHandler}
      title={
        <Text size="lg" fw="bold">
          History{section ? `, Deleted Row` : ""}
        </Text>
      }>
      {!section ? (
        <HistoryModalTable
          onSetSection={setSection}
          requestBody={requestBody}
          hideAutosave={hideAutosave}
        />
      ) : (
        section.rows &&
        (summary ? (
          <HistoryModalSection
            section={section}
            onNavigateBack={() => setSection(undefined)}
          />
        ) : (
          <HistoryModalGenerator
            section={section}
            onNavigateBack={() => setSection(undefined)}
          />
        ))
      )}
    </Modal>
  );
};

export default memo(HistoryModal);
